import LazyImage from "@/components/lazyImage/LazyImage";
import React from "react";
import { RecommendedBanner } from "./ProtectionFeatureCard";

const CardImage = ({ badge, imageUrl }: { imageUrl: string; badge?: React.ReactNode }) => (
  <div className="relative w-[8rem] md:w-[13.75rem]">
    {badge && <RecommendedBanner>{badge}</RecommendedBanner>}
    <LazyImage
      width={220}
      height={155}
      src={imageUrl}
      alt="Protection feature"
      className="h-full w-full object-contain md:object-cover"
    />
  </div>
);

export default CardImage;
